var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1667 14.75C10.1667 12.2187 12.2187 10.1667 14.75 10.1667C17.2813 10.1667 19.3333 12.2187 19.3333 14.75C19.3333 17.2813 17.2813 19.3333 14.75 19.3333C12.2187 19.3333 10.1667 17.2813 10.1667 14.75ZM14.75 8.5C11.2982 8.5 8.5 11.2982 8.5 14.75C8.5 18.2018 11.2982 21 14.75 21C16.1754 21 17.4894 20.5228 18.5409 19.7194L22.0774 23.2559C22.4028 23.5814 22.9305 23.5814 23.2559 23.2559C23.5814 22.9305 23.5814 22.4028 23.2559 22.0774L19.7194 18.5409C20.5228 17.4894 21 16.1754 21 14.75C21 11.2982 18.2018 8.5 14.75 8.5Z",
    fill: "#3451D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.83a022bd8f78355645c032f355daf074.svg";
export { ForwardRef as ReactComponent };